<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M15.3331 11.94C15.3465 12.44 15.2131 12.9133 14.9731 13.32C14.8398 13.56 14.6598 13.78 14.4598 13.96C13.9998 14.3867 13.3931 14.6467 12.7198 14.6667C11.7464 14.6867 10.8865 14.1867 10.4131 13.42C10.1598 13.0267 10.0065 12.5533 9.99979 12.0533C9.97979 11.2133 10.3531 10.4533 10.9531 9.95333C11.4065 9.58 11.9798 9.34667 12.6065 9.33334C14.0798 9.30001 15.2998 10.4667 15.3331 11.94Z"
      stroke="#A2A5B9"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.627 12.02L12.3003 12.66L13.6936 11.3133"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.11328 4.95996L7.99994 8.36662L13.8466 4.97994"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 14.4066V8.35992"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.4071 6.11331V9.88667C14.4071 9.92 14.4071 9.94664 14.4004 9.97997C13.9337 9.57331 13.3337 9.33333 12.6671 9.33333C12.0404 9.33333 11.4604 9.55333 11.0004 9.92C10.3871 10.4067 10.0004 11.16 10.0004 12C10.0004 12.5 10.1404 12.9733 10.3871 13.3733C10.4471 13.48 10.5204 13.58 10.6004 13.6733L9.38041 14.3467C8.62041 14.7733 7.3804 14.7733 6.6204 14.3467L3.0604 12.3733C2.25374 11.9267 1.59375 10.8067 1.59375 9.88667V6.11331C1.59375 5.19331 2.25374 4.07333 3.0604 3.62666L6.6204 1.65331C7.3804 1.22665 8.62041 1.22665 9.38041 1.65331L12.9404 3.62666C13.7471 4.07333 14.4071 5.19331 14.4071 6.11331Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "invertization",
};
</script>

<style lang="scss" scoped></style>
